import React from "react";
import {
  MdExplore,
  MdHotel,
  MdLocalAirport,
  MdRestaurant,
  MdSecurity,
  MdSupportAgent,
} from "react-icons/md";

const FeatureCard = ({ icon: Icon, title, description }) => {
  return (
    <div className="group p-6 rounded-xl bg-white shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer">
      <div className="flex flex-col items-center text-center">
        <div className="mb-4 p-3 bg-blue-50 rounded-full group-hover:bg-blue-100 transition-colors duration-300">
          <Icon className="w-8 h-8 text-blue-400" />
        </div>
        <h3 className="text-xl font-semibold mb-2">{title}</h3>
        <p className="text-gray-600">{description}</p>
      </div>
    </div>
  );
};

const FeaturesSection = () => {
  const features = [
    {
      icon: MdExplore,
      title: "Curated Experiences",
      description:
        "Hand-picked destinations and carefully crafted itineraries for unforgettable adventures.",
    },
    {
      icon: MdHotel,
      title: "Luxury Accommodations",
      description:
        "Stay in carefully selected premium hotels and unique local properties.",
    },
    {
      icon: MdLocalAirport,
      title: "Travel Support",
      description:
        "Comprehensive travel assistance including visa support and transport arrangements.",
    },
    {
      icon: MdRestaurant,
      title: "Local Cuisine",
      description:
        "Experience authentic local flavors with carefully selected dining experiences.",
    },
    {
      icon: MdSecurity,
      title: "Safe Travel",
      description:
        "24/7 emergency support and comprehensive travel insurance coverage.",
    },
    {
      icon: MdSupportAgent,
      title: "Expert Guides",
      description:
        "Professional local guides who bring destinations to life with their knowledge.",
    },
  ];

  return (
    <section className="py-16 px-4 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 ">
            Why Travel With Us
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto mb-4"></div>

          <p className="text-gray-600 max-w-2xl mx-auto">
            Discover what makes our tours unique and why thousands of travelers
            choose us for their adventures.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <FeatureCard key={index} {...feature} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
